export default {
  HomePage: {
    title: 'Estimator24 — Онлайн оценка недвижимости',
    description: 'ИИ-оценка квартир, домов и жилых комплексов в Европе и Турции.'
  },
  AboutPage: {
    title: 'О проекте Estimator24',
    description: 'Платформа для оценки, аналитики и инвестиций в недвижимость.'
  },
  PropertyList: {
    title: 'Каталог недвижимости — Estimator24',
    description: 'Все квартиры, виллы и дома с ИИ-оценкой. Поиск по странам, регионам и застройщикам.'
  },
  PropertyDetail: {
    title: '{title} — {city} — Estimator24',
    description: 'Подробная информация и ИИ-оценка недвижимости в {city}.'
  },
  DeveloperList: {
    title: 'Застройщики — Estimator24',
    description: 'Каталог застройщиков, строительных компаний и их проектов.'
  },
  DeveloperDetail: {
    title: '{developer} — Застройщик — Estimator24',
    description: 'Проекты и жилые комплексы застройщика {developer}.'
  },
  ResidentialComplexShow: {
    title: '{title} — Жилой комплекс — Estimator24',
    description: 'Описание, цены и планировки ЖК {title}.'
  },
  AgencyList: {
    title: 'Агентства недвижимости — Estimator24',
    description: 'Каталог агентств и их объектов по странам.'
  },
  AgencyDetail: {
    title: '{agency} — Агентство недвижимости — Estimator24',
    description: 'Объекты и контакты агентства {agency}.'
  },
  NewsList: {
    title: 'Новости рынка — Estimator24',
    description: 'Статистика, аналитика и тренды рынка недвижимости.'
  },
  NewsDetail: {
    title: '{title} — Новости Estimator24',
    description: '{excerpt}'
  },
  StatisticPage: {
    title: 'Статистика рынка — Estimator24',
    description: 'Показатели цен, объёмов продаж и строительства в реальном времени.'
  },
  PrivacyPolicy: {
    title: 'Политика конфиденциальности — Estimator24',
    description: 'Условия обработки данных пользователей и правила конфиденциальности.'
  }
}
